'use strict';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { hideAuthModal } from '../../app/Auth/actions';
import {breakLine} from '../../utils/formater';

class AuthModal extends PureComponent {
  constructor (props) {
    super(props);

    this.hideAuthModal = props.hideAuthModal.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.hideAuthModal();
  }

  render () {
    const auth = this.props.auth;
    const modalShow = auth.get('modalShow', false) || false;
    const modalText = auth.get('modalText');

    const modalClass = classNames('modal full-screen', {
      'open fade in': modalShow
    });

    return (
      <div className={modalClass}>
        <div className='modal-dialog full-screen'>
          <div className='modal-content animate-top'>
            <div className='modal-box auth-modal'>
              <button type='button' className='close' onClick={this.handlerClose}>×</button>
              {
                modalShow && (
                  <div className='form-container'>
                    <div className='message'>{breakLine(modalText)}</div>

                    <div className='controls'>
                      <a href='/user/default/login/' className='btn btn-primary'>Войти</a>
                      <a href='/user/default/registration/' className='btn btn-secondary'>Зарегистрироваться</a>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <TransitionGroup>
          {
            modalShow &&
            <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
              <div className='modal-backdrop full-screen' />
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
  }
}

AuthModal.propTypes = {
  auth: PropTypes.object.isRequired,
  hideAuthModal: PropTypes.func.isRequired
};

AuthModal.defaultProps = {};

function mapStateToProps (state) {
  return {
    auth: state.get('auth')
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    hideAuthModal
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal);



// WEBPACK FOOTER //
// ./src/ui/AuthForm/AuthModal.jsx